// extracted by mini-css-extract-plugin
module.exports = {"card":"winner-label_card__Pf7cB","list":"winner-label_list__r47gN"};